import firstImg from "./firstImg.jpg";
import "./styles.css";

export default function FirstImage() {
    return (
        <img src={firstImg} alt="Foto de Andres y Mafer" className="first-image"/>
    );
};